import type {ReactElement} from 'react';
import {getAssetUrl} from '@Utils/s3.util';
import {AiChatHalloweenAsset} from '@AiChat/lib/ai-chat-season-library.types';
import type {AiChatHalloweenPumpkinsProps} from './ai-chat-halloween-pumpkins.types';
import styles from './ai-chat-halloween-pumpkins.module.scss';

export function AiChatHalloweenPumpkins({pumpkinSetClasses}: AiChatHalloweenPumpkinsProps): ReactElement {
  return (
    <div className={`${styles.pumpkinSet} ${pumpkinSetClasses}`} aria-hidden="true">
      <img className={`${styles.pumpkin} ${styles.lantern}`} src={getAssetUrl(AiChatHalloweenAsset.PUMPKIN_LANTERN)} alt="" />
      <img className={`${styles.pumpkin} ${styles.angryPumpkin}`} src={getAssetUrl(AiChatHalloweenAsset.PUMPKIN_ANGRY)} alt="" />
      <img className={`${styles.pumpkin} ${styles.happyPumpkin}`} src={getAssetUrl(AiChatHalloweenAsset.PUMPKIN_HAPPY)} alt="" />
    </div>
  );
}
